"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Druid_1 = require("../../Druid");
const TypeGuard_1 = require("../../Types/TypeGuard");
class Button extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (ev) => {
            if (this.disabled === true) {
                ev.stopImmediatePropagation();
                ev.preventDefault();
            }
        });
    }
    set disabled(disabled) {
        this.attributeMap().toggle('disabled', disabled);
    }
    get disabled() {
        return this.hasAttribute('disabled');
    }
    /**
     * The button will be disabled on click, then the listener will be invoked.
     * If a promise is returned, the button will be enabled when the promise is resolved or rejected
     * Otherwise the button is enabled instantly
     */
    onClick(listener, options) {
        this.addEventListener('click', (event) => {
            this.disabled = true;
            const result = listener(event);
            // if result is promise, enable button when completed
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (TypeGuard_1.default.isPromise(result)) {
                result.finally(() => this.disabled = false);
            }
            else {
                this.disabled = false;
            }
        }, options);
        return this;
    }
    connectedCallback() {
        if (this.hasAttribute('tabindex') === false) {
            // make sure "Button" element is focusable
            this.setAttribute('tabindex', '0');
        }
    }
    setLabel(label) {
        this.innerHTML = label;
        return this;
    }
    setIcon(icon) {
        this.classList.add(icon);
        this.classList.add(Druid_1.default.configuration().icon.className);
        return this;
    }
}
exports.default = Button;
//# sourceMappingURL=Button.js.map